angular.module('login.social.facebook', ['security.service']);
angular.module('login.social.facebook').config(["$urlRouterProvider", function($urlRouterProvider) {
  $urlRouterProvider
    .when('/login/facebook/callback', ["$location", "$location2", "security", function($location, $location2, security) {
      // console.log( '>> login-facebook', security );
      var promise = security.socialLogin('facebook', $location.search())
        .then(function(data) {
          $location.search({});

          if(!data.success) {
            return;
          }

          if(security.isAdmin()) {
            return $location.path('/admin');
          }

          $location.path('/account');
        })
        .catch(function() {
          $location.search({});
          $location.path('/login');
        });

      return promise;
  }]);
}]);



// WEBPACK FOOTER //
// ./client/src/app/login/social/login-facebook.js